import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Window, Loading, EmptyState, StatusBadge } from "../../components/VB";

export default function IzinSaya() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/izin");
        setItems(data);
      } catch {}
      setLoading(false);
    })();
  }, []);

  return (
    <Window title="Izin Saya">
      {loading ? <Loading /> : items.length === 0 ? <EmptyState message="Belum ada izin diajukan" /> : (
        <table className="vb-table">
          <thead><tr><th>Tanggal</th><th>Jenis</th><th>Keterangan</th><th>Status</th><th>Catatan Admin</th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}>
                <td>{it.tanggal}</td>
                <td>{it.jenis}</td>
                <td>{it.keterangan}</td>
                <td><StatusBadge status={it.status} /></td>
                <td>{it.catatan_admin || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Window>
  );
}
